import { createAction } from "@reduxjs/toolkit";

export const closeNotification = createAction("notification/closeNotification");
